<script setup lang="ts">
import { CheckboxItem } from '@shared/ui/checkbox'

import { useTutorApplicationStore } from '../../model/store'
import { useAcceptNotRestrictedResident } from '../../model/legal-agreements/accept-not-restricted-resident.hooks'

defineOptions({
  name: 'AcceptNotRestrictedResident',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setAcceptNotRestrictedResident,
} = useAcceptNotRestrictedResident()

</script>

<template>
  <CheckboxItem
    :label="label"
    required
    :checked="tutorApplicationStore.form.acceptNotRestrictedResident"
    :mode="mode"
    @click="setAcceptNotRestrictedResident"
  />
</template>
